module.exports = __webpack_public_path__ + "static/img/scmbanner2.39193f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scmbanner2.png
// module id = KspD
// module chunks = 1